import { toast } from "sonner";
import { FileText, FileSpreadsheet, FileType, Download } from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { downloadExport, formatApiErrorDetail } from "@/lib/api";

function ExportRow({ label, hint, csvPath, pdfPath, csvName, pdfName, icon: Icon }) {
  const run = async (path, name) => {
    try {
      await downloadExport(path, name);
      toast.success("Esportazione avviata.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 card-hover">
      <div className="flex items-start gap-4">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0A1128] text-[#D4AF37]">
          <Icon className="h-6 w-6" />
        </span>
        <div className="flex-1">
          <h3 className="font-display text-lg font-semibold text-slate-900">{label}</h3>
          <p className="text-sm text-slate-500 mt-0.5">{hint}</p>
          <div className="mt-4 flex flex-wrap gap-3">
            <button onClick={() => run(csvPath, csvName)} data-testid={`export-${csvName}`}
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-5 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50">
              <FileSpreadsheet className="h-4 w-4" /> Esporta CSV
            </button>
            <button onClick={() => run(pdfPath, pdfName)} data-testid={`export-${pdfName}`}
              className="btn-gold inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold">
              <FileType className="h-4 w-4" /> Esporta PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AdminReports() {
  return (
    <DashboardLayout title="Report" admin>
      <div className="flex items-center gap-2 text-slate-500 mb-6">
        <Download className="h-5 w-5" />
        <p className="text-sm max-w-2xl">Esporta pratiche e merito fidelizzazione per la gestione amministrativa e fiscale, in formato CSV (fogli di calcolo) o PDF (stampa/archiviazione).</p>
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        <ExportRow icon={FileText} label="Segnalazioni" hint="Tutte le pratiche con stato, valore affare e chiusura."
          csvPath="/admin/export/referrals.csv" pdfPath="/admin/export/referrals.pdf"
          csvName="segnalazioni.csv" pdfName="segnalazioni.pdf" />
        <ExportRow icon={FileText} label="Merito fidelizzazione" hint="Merito fidelizzazione per segnalatore, stato e importi maturati/pagati."
          csvPath="/admin/export/commissions.csv" pdfPath="/admin/export/commissions.pdf"
          csvName="merito-fidelizzazione.csv" pdfName="merito-fidelizzazione.pdf" />
      </div>
    </DashboardLayout>
  );
}
